export const BLOG_CATEGORY_URL = "blog-category";
export const blogCategoryByIdUrl = (id) => `blog-category/${id}`;
